// extracted by mini-css-extract-plugin
export var container = "_2d-0";